import script from "./dashboard-theme-mode-toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard-theme-mode-toggle.vue?vue&type=script&setup=true&lang=ts"

import "./dashboard-theme-mode-toggle.vue?vue&type=style&index=0&id=c9c167c6&lang=scss&scoped=true"
import "./dashboard-theme-mode-toggle.vue?vue&type=style&index=1&id=c9c167c6&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9c167c6"]])

export default __exports__